export const getAuthToken = () => {
  return sessionStorage.getItem('authToken');
};

export const getAuthType = () => {
  return sessionStorage.getItem('authType');
};

export const getCartId = () => {
  return sessionStorage.getItem('cart_id');
};